import type {ComponentType} from 'react';

import classnames from 'classnames';

import {ButtonCard} from 'shells/card/button-card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error
import {DragHandleIcon} from 'shells/icon/svg/drag-handle-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './field-card-preview.module.css';

interface Props {
    Icon: ComponentType<any>;
    label: string;
    isDragging?: boolean;
    inDragOverlay?: boolean;
    isDisabled?: boolean;
}

export function FieldCardPreview(props: Props) {
    const visuallyDisabled = props.isDragging || props.isDisabled;

    return (
        <ButtonCard
            // pass noop onClick to give the card hover state
            onClick={() => {}}
            showDisabledOverlay={true}
            isDisabled={visuallyDisabled}
            isFullWidth={true}
            className={classnames(styles['field-card'], {
                [styles['field-card--in-drag-overlay']]: props.inDragOverlay,
                [styles['field-card--disabled']]: props.isDisabled,
            })}
        >
            <div className='pad-8'>
                <Stack
                    alignItems='center'
                    justifyContent='space-between'
                    isFullHeight={true}
                    isFullWidth={true}
                    spacing={4}
                >
                    <props.Icon size={16} color={colors.grey} fill={colors.grey} />
                    <Body size='tiny' color='dark' textAlign='center'>
                        {props.label}
                    </Body>
                    <div className={styles['drag-handle-container']}>
                        <DragHandleIcon size={14} />
                    </div>
                </Stack>
            </div>
        </ButtonCard>
    );
}
